import React from "react";
import PrimaryCTA from "@mytutor/shared-react-web-components/lib/PrimaryCTA";
import { colors } from "@mytutor/shared-react-web-components/lib/theme";
import { css } from "@emotion/react";
import { InfoBox } from "../InfoBox";

type Props = {
  isAuthenticated: boolean;
};

export const ContactUsBox = ({ isAuthenticated }: Props) => {
  const title = "Looking for something specific?";
  const body = "Let us know what you're looking for and our tutor matching team will help you find the perfect fit.";

  const authStyles = css({
    backgroundColor: isAuthenticated ? colors.primary1 : "white",
    border: isAuthenticated ? `1px solid ${colors.primary5}` : "none",
  });

  return (
    <InfoBox
      additionalStyles={authStyles}
      image={{
        src: `${process.env.NEXT_PUBLIC_CDN_URL}/fleet/icons/chat-balloons-primary5.svg`,
        alt: "Chat with support",
        height: 127,
        width: 178,
      }}
      title={title}
      body={body}
    >
      {isAuthenticated ? (
        <div className="authenticated-cta">
          <a href="tel:+442037736024" rel="nofollow">
            +44 (0) 203 773 6024
          </a>
          <p>Our opening hours are Mon to Fri 9am to 6pm</p>
        </div>
      ) : (
        <>
          <a
            className="cta-button"
            href={`${process.env.NEXT_PUBLIC_ZEUS_URL}/get-started`}
          >
            <PrimaryCTA> Find me a tutor </PrimaryCTA>
          </a>
          <p>
            Or call{" "}
            <a href="tel:+442037736024" rel="nofollow">
              <strong>+44 (0) 203 773 6024</strong>
            </a>{" "}
            to speak to a tutor expert
          </p>
        </>
      )}
    </InfoBox>
  );
};
